import React, { useState } from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import './App.css';

const events = [
  {
    title: 'The Bel Canto - 2024 Opera Concert',
    description: 'The Concert was held for the first time in Sri Lanka on January 22, 2024, at Lionel Wendt Theater, Colombo. It featured Prof. Yan Min Tao and Prof. Shen Yang from Nanjing Normal University with 17 artists, alongside a guest performance by Mrs. Gayathri Khemadasa and students of the Khemadasa Foundation.',
    image: './images/bel.jpg',
    images: [
      './images/Photo/Opera3.jpg',
      './images/Photo/Opera4.jpg',
      './images/Photo/Opera5.jpg',
      './images/Photo/Opera6.jpg',

    ],
  },
  {
    title: 'Authentic Sri Lankan Culinary & Cultural Experience',
    description: 'Experience the authentic taste of Sri Lanka through our cultural cooking sessions. Learn to prepare signature dishes with local chefs, and discover the stories behind our vibrant spices. Enjoy traditional music, attire, and warm island hospitality more than a meal, it’s a cultural journey.',
    image: './images/cook.jpeg',
    images: [
      './images/Photo/ST8.jpeg',
      './images/Photo/ST6.jpeg',
      './images/Photo/ST4.jpeg',
      './images/cook.jpeg',
    ],
  },
  {
    title: 'Welcome to China 2024',
    description: 'In 2024, the founders of Wasala Tours journeyed to China to broaden their travel expertise and form global partnerships. The experience strengthened cultural ties and laid the foundation for future exchanges between Sri Lanka and China, marking a key step in their mission to connect people through authentic travel.',
    image: './images/welcome.jpeg',
    images: [
 './images/welcome.jpeg',
    ],
  },
  {
    title: 'Happy 77th Independence Day Sri Lanka 🇱🇰 2025',
    description: 'In 2025, we welcomed travelers to Sri Lanka during the 77th Independence Day a special time to experience the island’s heritage, pride, and vibrant celebrations. From ancient sites to streets alive with national color, it was Sri Lanka at its most spirited.',
    image: './images/nai1.jpg',
    images: [
'./images/nai1.jpg',
    ],
  },
  {
    title: 'Welcome to Sri Lanka 🇱🇰 2025',
    description: 'In 2025, we proudly shared Sri Lanka’s beauty with travelers from around the world. From Sigiriya’s majesty to golden beaches, serene temples, and vibrant traditions, each moment captured the island’s warmth and charm turning every trip into a story of discovery and joy.',
    image: './images/nai2.jpg',
    images: [
 './images/nai2.jpg',
    ],
  },
];

const responsive = {
  desktop: { breakpoint: { max: 3000, min: 1024 }, items: 3 },
  tablet: { breakpoint: { max: 1024, min: 768 }, items: 2 },
  mobile: { breakpoint: { max: 768, min: 0 }, items: 1 },
};

const responsiveModal = {
  all: { breakpoint: { max: 4000, min: 0 }, items: 1 },
};

const WasalEvents = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalImages, setModalImages] = useState([]);
  const [modalTitle, setModalTitle] = useState('');

  const openModal = (event) => {
    setModalImages(event.images);
    setModalTitle(event.title);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  return (
    <div className="wasal-events-container">
      <h2 className="events-heading">Our Journey in Moments</h2>

      <Carousel
        responsive={responsive}
        infinite={true}
        autoPlay={false}
        keyBoardControl={true}
        containerClass="carousel-container"
        itemClass="carousel-item-padding-40-px"
        arrows={true}

      >
        {events.map((event, index) => (
          <div className="event-card" key={index}>
            <div className="event-image-container">
              <img src={event.image}  className="event-image" />
            </div>
            <div className="event-title-container">
              <h3>{event.title}</h3>
            </div>
            <div className="event-description-container">
              <p>{event.description}</p>
            </div>
            <div className="event-button-container">
              <button onClick={() => openModal(event)} className="more-btn">More Gallery..</button>
            </div>
          </div>

        ))}
      </Carousel>

      {/* Modal Popup Carousel */}
      {modalOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content2" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={closeModal}>&times;</button>
            {/* REMOVE or COMMENT this line below if not needed */}
            {/* <h3>{modalTitle}</h3> */}
            <div className="carousel-container2">
              <Carousel
                responsive={responsiveModal}
                infinite={true}
                autoPlay={true}
                keyBoardControl={true}
                showDots={false}
                arrows={true}
              >
                {modalImages.map((img, idx) => (
                  <div key={idx}>
                    <img src={img}  className="modal-image" />
                  </div>
                ))}
              </Carousel>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default WasalEvents;
